import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { ORSAN_LOGO_URL } from 'CONST';
import ReaseguroNavBar from './navegacion/ReaseguroNavBar';
import ReservaNavBar from './navegacion/ReservaNavBar';
import { signout } from '../helpers/auth';
import getUserHome from '../helpers/routeHelper';
import NotificationBell from './shared/NotificationBell';

import '../styles/navbar.css';

class BaseNavbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      app: 'reserva',
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const app = location.pathname.split('/')[1];
    this.setState({ app });
  }

  handleSignOut = (event) => {
    event.preventDefault();
    signout();
  };

  getSelectedClass = (path, exact = false) => {
    const currentPath = window.location.pathname;
    const homeReaseguros = "/reaseguros/contratos";

    // Maneja un arreglo the "paths"
    if (Array.isArray(path)) {
      if (path.some(p => exact ? currentPath === p : currentPath.startsWith(p)))
        return 'nav-selected';
    }

    if (typeof path === 'string') {
      if (exact ? currentPath === path : currentPath.startsWith(path))
        return 'nav-selected';
    }

    if (["/reservas", "/"].includes(currentPath)) {
      const { path: homePath } = getUserHome();

      // Maneja el "home path"
      if (Array.isArray(path) ? path.includes(homePath) : homePath === path)
        return 'nav-selected';
    }

    if (currentPath === "/reaseguros") {
      if (homeReaseguros === path)
        return 'nav-selected';
    }

    return '';
  };

  render() {
    const { user } = this.props;
    const { app } = this.state;

    return (
      user && (
        <>
          <nav className="navbar-content">
            <div className="nav-logo-container">
              <Link to={app === 'reaseguros' ? "/reaseguros" : "/reservas"}>
                <img src={ORSAN_LOGO_URL} className="nav-logo" alt="" />
              </Link>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
              {app === 'reaseguros' ?
                <ReaseguroNavBar getSelectedClass={this.getSelectedClass} /> :
                <ReservaNavBar getSelectedClass={this.getSelectedClass} />
              }
              <ul className="nav-links-group">
                <li className="nav-link-element nav-ite">
                  <NotificationBell />
                </li>
                <li className="nav-link-element nav-ite dropdown">
                  <p className="nav-link">{user ? user.username : ''}</p>
                </li>
                <li className="nav-link-element nav-item dropdown">
                  <button type="button" className="btn btn-outline-orsan-logout mr-3" onClick={this.handleSignOut}>
                    Cerrar Sesión
                    <FontAwesomeIcon icon={faSignOutAlt} size="1x" className="ml-2" />
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </>
      )
    );
  }
}

BaseNavbar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    email: PropTypes.string,
    username: PropTypes.string,
    full_name: PropTypes.string,
    has_access: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.string),
    organization: PropTypes.number,
    sub: PropTypes.string,
    profiles: PropTypes.array,
  }).isRequired,
};

const mapStateToProps = (state) => ({ user: state.login.user });

export default withRouter(connect(mapStateToProps)(BaseNavbar));
